import { PlanType } from '@showbie-socrative/socrative-utils';

import { useAccount } from '~teacher/hook/account';

const Constants = require('Constants');

const roomLimitMap: Partial<Record<PlanType, number>> = {
  [PlanType.Pro]: Constants.MAX_PRO_ROOMS,
  [PlanType.Organization]: Constants.MAX_ORGANIZATION_ROOMS,
  [PlanType.Complete]: Constants.MAX_COMPLETE_ROOMS,
  [PlanType.Essentials]: Constants.MAX_ESSENTIALS_ROOMS,
  [PlanType.Starter]: Constants.MAX_STARTER_ROOMS,
};

function getRoomLimit(plan: PlanType) {
  return roomLimitMap[plan] ?? 1;
}

export const useRoomLimit = () =>
  useAccount({
    select: ({ plan }) => getRoomLimit(plan) ?? 1,
  });
